import { Box, Modal, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import IconButton from "../../../../components/buttons/IconButton";
import TextButton from "../../../../components/buttons/TextButton";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { icons } from "../../../stack/environment/icons/iconExport";

export default function AINotIncludedModal({ open, setOpen }) {
  const colors = useColors();

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box
        display="flex"
        flexDirection="column"
        gap={2}
        top="50%"
        left="50%"
        position="absolute"
        sx={{
          backgroundColor: colors.modal_bg,
          transform: "translate(-50%, -50%)",
          outline: "none",
          padding: "24px",
          borderRadius: "10px",
          boxShadow: "0px 0px 4px 1px " + colors.grey_24percent,
        }}
      >
        <Box display="flex" flexDirection="column" gap={2}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="relative"
          >
            <Typography variant="subtitle1" color={colors.text_primary}>
              AI Posture isn’t included in your plan
            </Typography>
            <Box position="absolute" right="-8px" top="-8px">
              <IconButton
                onClick={() => setOpen(false)}
                IconSVG={icons.CloseIcon}
                size="XS"
                buttonStyle="standard"
                color="inherit"
              />
            </Box>
          </Box>
          <Box display="flex" flexDirection="column" gap="12px" width="541px">
            <Typography variant="body2" color={colors.text_primary}>
              AI Posture adds continuous monitoring and exposure insights for AI
              security.
            </Typography>
            <Typography variant="subtitle2" color={colors.text_primary}>
              Contact us to enable AI Posture and unlock:
            </Typography>
            <Box display="flex" flexDirection="column" gap={1}>
              {[
                "AI usage and adoption visibility",
                "MCP exposure insights",
                "NHI risk coverage",
              ].map((text) => (
                <Box key={text} display="flex" alignItems="center" gap={1}>
                  <SvgToIcon
                    IconLogo={icons.DoneIcon}
                    width="16px"
                    height="16px"
                    style={{ color: colors.icon_action_active }}
                  />
                  <Typography variant="body2" color={colors.text_primary}>
                    {text}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
        <Box
          display="flex"
          gap={3}
          justifyContent="flex-end"
          alignItems="center"
        >
          <TextButton
            onClick={() => setOpen(false)}
            size="medium"
            color="inherit"
          >
            Not now
          </TextButton>
          <TextButton
            onClick={() => {
              window.location.href = "mailto:support@breezesec.com";
            }}
            size="medium"
            color="primary"
          >
            Contact us
          </TextButton>
        </Box>
      </Box>
    </Modal>
  );
}
